import { Controller } from "@hotwired/stimulus"

// Populates a hidden item_ids field from checked .mass_update_checkbox inputs
// before the bulk action form submits. Scans the entire page since the
// checkboxes are in a sibling table, not inside this form.
export default class extends Controller {
  static targets = ["itemIds"]

  fillIds() {
    const ids = Array.from(document.querySelectorAll('.mass_update_checkbox input:checked'))
      .map(cb => cb.value)
      .join(',')
    this.itemIdsTarget.value = ids
  }
}
